import { BrowserRouter, Routes, Route } from "react-router-dom";
import React, { useEffect } from 'react';
import Login from "./Pages/Login/Login";
import Main from "./Pages/Main/Main";
import FA from "./Pages/Login/2FA/FA";
import Password from "./Pages/Login/Password/Password";
import Email from "./Pages/Login/Password/Email";
import AdminHome from "./Pages/administration/administrationHome/AdministrationHome";
import NutzerAnlegen from "./Pages/administration/NutzerAnlegen/NutzerAnlegen";
import NutzerVerwalten from "./Pages/administration/NutzerVerwaktung/NutzerVerwaltung";
import GruppenVerwaltung from "./Pages/administration/GrupppenVerwaltung/GruppenVerwaltung";
import EventVerwaltung from "./Pages/administration/EventsVerwaltung/EventVerwaltung";
import Veranstatungallgemein from "./Pages/verein/allgemein/Vereinallgemein";
import Pagehistory from "./Pages/history/Pagehistory";
import Fbeschreibung from "./Pages/verein/fbeschreibung/Fbeschreibung";
import Nutzerdateien from "./Pages/verein/nutzerdatein/Nutzerdateien";
import FileSystem from "./Pages/FileSystem/FileSystem";
import VergleichsKathegorien from "./Pages/Vergleiche/VergleichsKathegorien/VergleichsKathegorien";
import SubKathegorieCreation from "./Pages/Vergleiche/VergleichsKathegorien/SubKathegorieCreation";
import SubKathegorie from "./Pages/Vergleiche/VergleichsKathegorien/components/SubKathegorie";
import VergleichsSubhome from "./Pages/Vergleiche/VergleichSubKathegorie/VergleichsSubkathegorieHome/VergleichsSubhome";
import Gesellschaftenhome from "./Pages/Vergleiche/Gesellschaften/Gesellschaftenhome";
import Tarif from "./Pages/Vergleiche/VergleichSubKathegorie/Tarif/Tarif";
import TarifstandCreator from "./Pages/Vergleiche/VergleichSubKathegorie/Tarif/Tarifstände/TarifstandCreator";
import FilePrüfer from "./Pages/Vergleiche/VergleichSubKathegorie/Tarif/FilePrüfung/FilePrüfer";
import TarifStandFragenEditor from "./Pages/Vergleiche/VergleichSubKathegorie/Tarif/Tarifstände/TarifStandFragenEditor";
import HistoryTable from "./Pages/history/components/HistoryTable";
import TarifStanddateienEditor from "./Pages/Vergleiche/VergleichSubKathegorie/Tarif/Tarifstände/TarifStanddateienEditor";
import EmpfehlungsStandeditor from "./Pages/Vergleiche/VergleichSubKathegorie/Tarif/Tarifstände/EmpfehlungsStandeditor";
import TarifstandEmpfehlungHistory from "./Pages/history/components/TarifstandEmpfehlungHistory";
import VergleichHome from "./Pages/Vergleiche/Vergleichen/VergleichHome";
import BestTarifErgebniss from "./Pages/Vergleiche/Vergleichen/components/BestTarifErgebniss";
import VergleichErgebniss from "./Pages/Vergleiche/Vergleichen/components/VergleichErgebniss";
import Beschlussbuch from "./Pages/verein/beschlussbuch/Beschlussbuch";
import NutzerVereinsdatenViewer from "./Pages/verein/nutzerdatein/NutzerVereinsdatenViewer";
import Vereinsdateien from "./Pages/verein/vereinsdatein/Vereinsdateien";
import ListViewVerein from "./Pages/verein/ListsViews/ListViewVerein";
import Downloads from "./Pages/Downloads/Downloads";
import MyProfile from "./Pages/Profil/MyProfile";
import MeinBetrieb from "./Pages/Profil/Betriebe/MeinBetrieb";
import BetriebsViewer from "./Pages/Profil/Betriebe/BetriebsViewer";
import Betriebsliste from "./Pages/Profil/Betriebe/Betriebsliste";
import UserList from "./Pages/verein/UserList/UserList";
import Protokolle from "./Pages/Protokolle/Protokolle";
import Regionalgruppen from "./Pages/administration/Reggruppen/Regionalgruppen";
import RegionalgruppeZuweisen from "./Pages/administration/Reggruppen/RegionalgruppeZuweisen";
import RegionalgruppenView from "./Pages/Profil/Regionalgruppen/RegionalgruppenView";
import PunkteKonto from "./Pages/PunkteKonto/PunkteKonto";
import Aktivitäten from "./Pages/aktivitäten/Aktivitäten";
import AktivityViewer from "./Pages/aktivitäten/components/AktivityViewer";
import Foren from "./Pages/Forum/Foren";
import ForumViewer from "./Pages/Forum/ForumViewer";
import ForumThemenViewer from "./Pages/Forum/ForumThemenViewer";
import Organisation from "./Pages/Organisation/Organisation";
import OrganisationTable from "./Pages/Organisation/OrganisationTable";
import DetailsViewer from "./Pages/PunkteKonto/components/DetailsViewer";
function App() {
  useEffect(() => {
    console.log("App opened");


    const handleBeforeUnload = (event) => {
      console.log("App is about to close");

    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
  
    };
  }, []);


  return (
    <>
     <BrowserRouter>
        <Routes>
          <Route path="/">
          <Route index element={<Login />} />
          <Route path="/forgottpw" element={<Password />} />
          <Route path="/forgottpw_email" element={<Email />} />
          <Route path="/2auth" element={<FA/>} />
          <Route path="/home" element={<Main/>} />
          <Route path="/verwaltung-home" element={<AdminHome/>}/>
          <Route path="/verwaltung-nutzer-anlegen" element={<NutzerAnlegen/>}/>
          <Route path="/verwaltung-nutzer-verwalten" element={<NutzerVerwalten/>}/>
          <Route path="/verwaltung-gruppen-verwalten" element={<GruppenVerwaltung/>}/>
          <Route path="/verwaltung-event-verwalten" element={<EventVerwaltung/>}/>
          <Route path="/verein-allgemein" element={<Veranstatungallgemein/>}/>
          <Route path="/page-history/:page" element={<Pagehistory/>}/>
          <Route path="/f-beschreibungen" element={<Fbeschreibung/>}/>
          <Route path="/verein-nutzerdatein" element={<Nutzerdateien/>}/>
          <Route path="/filesystem/:id/:name/:ipend/" element={<FileSystem/>}/>
          <Route path="/vergleichsKathegorien" element={<VergleichsKathegorien/>}/>
          <Route path="/create-sub-sparte/:overname/:creation/:id" element={<SubKathegorieCreation/>}/>
          <Route path="/VergleichsSubhome/:kath/:id" element={<VergleichsSubhome/>}/>
          <Route path="/gesellschaften" element={<Gesellschaftenhome/>}/>
          <Route path="/tarif/:id/:overkath" element={<Tarif/>}/>
          <Route path="/create-tarif-after-first/:id/:hold" element={<TarifstandCreator/>}/>
          <Route path="/file_prüfer/:fileid/:dateiname/:subkath/:perms/:type/:stand" element={<FilePrüfer/>}/>
          <Route path="/tarif_stand_edit_fragen/:id" element={<TarifStandFragenEditor/>}/>
          <Route path="/history_table" element={<HistoryTable/>}/>
          <Route path="/edit_tarifstand_dateien/:additional/:subkath/:type" element={<TarifStanddateienEditor/>}/>
          <Route path="/edit_tarifstand_empfehlung" element={<EmpfehlungsStandeditor/>}/>
          <Route path="/tarifstand_empfehlung_log/:additional" element={<TarifstandEmpfehlungHistory/>}/>
          <Route path="/vergleich-home" element={<VergleichHome/>}/>
          <Route path="/get_best_ergebniss" element={<BestTarifErgebniss/>}/> 
          <Route path="/vergleichs_ergebniss" element={<VergleichErgebniss/>}/>
          <Route path="/beschlussbuch" element={<Beschlussbuch/>}/>
          <Route path="/view_uservereinsdata/:id/:name" element={<NutzerVereinsdatenViewer/>}/>
          <Route path="/verein-datein" element={<Vereinsdateien/>} />
          <Route path="/listview/:a" element={<ListViewVerein/>}/>
          <Route path="/downloads" element={<Downloads/>}/>
          <Route path="/my-profile/:id" element={<MyProfile/>}/>
          <Route path="/my-betriebe" element={<MeinBetrieb/>} />
          <Route path="/view-betrieb/:id" element={<BetriebsViewer/>}/>
          <Route path="/betriebsliste" element={<Betriebsliste/>}/>
          <Route path="/userlist" element={<UserList/>}/>
          <Route path="/protokolle" element={<Protokolle/>}/>
          <Route path="/regionalgruppen" element={<Regionalgruppen/>}/>
          <Route path="/regionalgruppe_zuweisen" element={<RegionalgruppeZuweisen/>}/>
          <Route path="/regionalgruppen_view" element={<RegionalgruppenView/>}/>
          <Route path="/punktekonto" element={<PunkteKonto/>}/>
          <Route path="/aktivitäten" element={<Aktivitäten/>}/>
          <Route path="/aktivityviewer/:id" element={<AktivityViewer/>}/>
          <Route path="/foren" element={<Foren/>}/>
          <Route path="/viewforum/:id" element={<ForumViewer/>}/>
          <Route path="/viewthemaForum/:forenid/:id" element={<ForumThemenViewer/>}/>
          <Route path="/organisation" element={<Organisation/>}/>
          <Route path="/organisation_view/:id" element={<OrganisationTable/>}/>
          <Route path="/punktekonto_details/:id" element={<DetailsViewer/>}/>
          <Route default element={<Login />} />
        
          </Route>
        </Routes>
     </BrowserRouter>
    </>
  );
}

export default App;
